var angular = require('angular');
var _module = require('../module');
var _ = require('lodash');

require('../third-party/angular-click-outside');
require('../../services/login-or-register-modal');
require('../../services/lr-touch');
require('../../services/search-results-utils');
require('../../services/user');

_module.requires.push('angular-click-outside');

_module.component('lrheader', {
    bindings: {
        showBackground: '<',
        headerClass: '<',
        hideHeaderLinks: '<',
        showListReportsLogo: '<'
    },
    controllerAs: 'lrheader',
    controller: [
        '$log',
        '$rootScope',
        '$scope',
        '$state',
        'Listing',
        '$loginOrRegisterModal',
        '$thankyouModal',
        '$user',
        'srUtils',
        '$location',
        '$window',

        function lrheaderCtrl($log, $rootScope, $scope, $state, Listing, $loginOrRegisterModal, $thankyouModal, $user, srUtils, $location, $window) {
            var _this = this;
            
            _this.listingService = Listing;
            _this.$user = $user;
            _this.$state = $state;
            _this.isMobile = function() { return srUtils.isMobile(); };

            var initLayout = function () {
                _this.layout = {
                    currentState: null
                };
            };

            var initBackButton = function (state) {
                var isMobile = srUtils.isMobile();
                _this.showBackButton = (isMobile && ['viewlisting'].indexOf(state.name) >= 0);
            };

            var initAuthQueryParam = function () {
                _this.queryParams = {};
                if($location.search() && $location.search().a && $user.account_type === 'guest') {
                    _this.queryParams.a = $location.search().a;
                }
            };

            var init = function () {
                _this.user = $user;
                initAuthQueryParam();
                initLayout();
            };

            init();

            // Functions
            this.goHome = function () {
                $state.go('homepage');
            };

            this.goBack = function () {
                if(_.has(_this, 'layout.prevState.name') && _this.layout.prevState.name.length){

                    if(_this.layout.prevStateParams) {
                        var paramsObj = angular.extend({}, _this.queryParams, _this.layout.prevStateParams);
                        $state.go(_this.layout.prevState.name, paramsObj);
                    }else{
                        $state.go(_this.layout.prevState.name, _this.queryParams);
                    }
                }else{
                    $state.go('homepage');
                }

            };

            this.goToLink = function (link) {
                $window.open(link);
            };

            $scope.$on('$stateChangeSuccess',
                function(event, toState, toParams, fromState, fromParams) {
                    if( _.get(toState, 'name') !== _.get(fromState, 'name') ) {
                        _this.layout.currentState = toState;
                        _this.layout.prevState = fromState;
                        _this.layout.prevStateParams = fromParams;
                        $log.debug('Route Changed Saved!', {toState: toState, toParams: toParams, fromState: fromState, fromParams: fromParams});
                    }
                    initBackButton(toState);
                }
            );
        }
    ],
    template: require('./index.html')
});
